import axios from 'axios';
import { VERSION, REQUEST_TIME_OUT } from '../../../config';
import {
	ERROR,
	NO_RESPONSE,
	NOT_VALID,
	SUCCESS,
	sendResponse,
	sendErrorResponse,
	isSuccessRequest,
	postEventApiUrl,
} from '../utils';
import { EventType } from './EventType';
import { EventResponseTypes } from './types';

function getPayloadForHitEvent(
	campaignId: string = '',
	contentId: string = ''
): {
	campaignId: string;
	contentId: string;
} {
	return { campaignId, contentId };
}

function getPayloadForLoadEvent(url: string = ''): {
	url: string;
} {
	return { url };
}

function getPayloadForClickEvent(
	campaignId: string = '',
	contentId: string = '',
	url: string = ''
): {
	campaignId: string;
	contentId: string;
	url: string;
} {
	return { campaignId, contentId, url };
}

export function getPayload({
	eventType = EventType.LOAD,
	campaignId = '',
	contentId = '',
	url = '',
}: {
	eventType: EventType;
	campaignId?: string;
	contentId?: string;
	url?: string;
}):
	| {
			campaignId: string;
			contentId: string;
	  }
	| {
			url: string;
	  }
	| {
			campaignId: string;
			contentId: string;
			url: string;
	  } {
	if (eventType === EventType.LOAD) {
		return getPayloadForLoadEvent(url);
	}
	if (eventType === EventType.CLICK) {
		return getPayloadForClickEvent(campaignId, contentId, url);
	}
	return getPayloadForHitEvent(campaignId, contentId);
}

export async function PostEvent({
	environment = '',
	clientId = '',
	sessionId = '',
	campaignId = '',
	contentId = '',
	url = '',
	previewQuery = {},
	eventType = EventType.LOAD,
	requestTimeout = REQUEST_TIME_OUT,
}: {
	environment: string;
	clientId: string;
	sessionId: string;
	campaignId?: string;
	contentId?: string;
	url?: string;
	eventType: EventType;
	requestTimeout?: number;
	previewQuery?: object;
}): Promise<EventResponseTypes> {
	try {
		const apiURL = postEventApiUrl(environment);
		const payload = getPayload({ eventType, campaignId, contentId, url });
		const data = {
			eventType,
			payload,
		};

		const jsonResponse = await axios.post(apiURL, data, {
			headers: {
				'X-RMC-Client-ID': clientId,
				'X-RMC-Session': sessionId,
				'X-RMC-SDK-Version': VERSION,
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			params: { ...previewQuery },
			timeout: requestTimeout,
			withCredentials: true,
		});
		const { status } = jsonResponse;

		if (isSuccessRequest(status)) {
			return sendResponse(SUCCESS, [{ ...payload, eventType }]);
		}

		return sendErrorResponse(NOT_VALID, jsonResponse, 1);
	} catch (e: any) {
		if (e.response) {
			return sendErrorResponse(NOT_VALID, e.message, 1);
		}

		if (e.request) {
			return sendErrorResponse(NO_RESPONSE, e.message, 1);
		}
		return sendErrorResponse(ERROR, e.message, 1);
	}
}
